import React, { FC } from "react";
import type { PlatformReplaceDataProps } from "@/types";
import { TextCols } from "../text-cols";

export const PlatformReplaceData: FC<PlatformReplaceDataProps> = (props) => {
  return (
    <section className="platformReplaceData">
      <div className="wrapper">
        <TextCols content={props} size="md" />
      </div>
    </section>
  );
};
